import { siteInfo, footerLinks } from '@/mocks/homeData';

export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 pt-14 pb-8">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-10 border-b border-background-800/50">
          <div className="lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollTo('#hero');
              }}
              className="flex items-center gap-2 text-background-50 no-underline mb-4"
            >
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-base"></i>
              </div>
              <span className="text-lg font-heading font-bold">{siteInfo.name}</span>
            </a>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              麻花视频提供海量电视剧免费在线观看，涵盖最新电视剧全集、高清电视剧不缓冲播放，电影免费看，无需会员即可享受流畅观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.href);
                    }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-4">内容</h4>
            <ul className="space-y-2.5">
              {footerLinks.content.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollTo(link.href);
                    }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors no-underline"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500">虚位以待</p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-xs text-foreground-500">
            &copy; 2026 {siteInfo.name}. 本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="text-foreground-400 hover:text-primary-400 transition-colors no-underline">
              <i className="ri-arrow-up-circle-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}